export function getCommunitiesRoutes() {
  return [
    {
      path: "/communities",
      name: "communities",
      component: () => import("./views/CommunitiesList.vue"),
    },
    {
      path: "/communities/detail/:communityId",
      component: () => import("./views/CommunityEditWrapper.vue"),
      name: "communities/communities-detail",
      children: [
        {
          path: "general",
          name: "communities/communities-general",
          component: () => import("./views/CommunityEditGeneral.vue"),
          meta: {
            module: "communities",
          },
        },
        {
          path: "posts",
          name: "communities/communities-posts",
          component: () => import("./views/CommunityPosts.vue"),
          meta: {
            module: "communities",
          },
        },
        {
          path: "users",
          name: "communities/communities-users",
          component: () => import("./views/CommunityUsers.vue"),
          meta: {
            module: "communities",
          },
        },
        {
          path: "hot-topics",
          name: "communities/communities-hot-topics",
          component: () => import("./views/CommunityHotTopics.vue"),
          meta: {
            module: "communities",
          },
        },
      ],
    },
  ]
}
